import { render, staticRenderFns } from "./EstimateResult.vue?vue&type=template&id=24ad34ba&scoped=true&"
import script from "./EstimateResult.vue?vue&type=script&lang=js&"
export * from "./EstimateResult.vue?vue&type=script&lang=js&"
import style0 from "./EstimateResult.vue?vue&type=style&index=0&id=24ad34ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ad34ba",
  null
  
)

export default component.exports